/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import ExpandMoreSharpIcon from '@material-ui/icons/ExpandMoreSharp';
import { Menu, MenuItem, Box, Typography } from '@material-ui/core';
import { ButtonLink } from '../Table/Table.styles';

const MoreActionMenu: React.FC<{
  onGenerateReport: () => void;
  onHoldOrRelease: () => void;
  onIssueReport: () => void;
  onSoaPrint: () => void;
  disableGenerateReport?: boolean;
  disableIssueReport?: boolean;
  disableSoaPrint?: boolean;
}> = ({
  onGenerateReport,
  onHoldOrRelease,
  onIssueReport,
  onSoaPrint,
  disableGenerateReport,
  disableIssueReport,
  disableSoaPrint,
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLAnchorElement | null>(null);

  const handleMenuClickOpen = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (): void => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
      <ButtonLink
        onClick={handleMenuClickOpen}
        variant="button"
        underline="none"
        color="primary"
        data-testid="actions-select"
      >
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <Typography color="inherit" variant="subtitle2">
            ...
          </Typography>
          <ExpandMoreSharpIcon />
        </Box>
      </ButtonLink>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
      >
        <MenuItem
          disabled={disableGenerateReport}
          onClick={() => onGenerateReport()}
          data-testid="generateOneReport"
        >
          Generate reports
        </MenuItem>
        <MenuItem onClick={() => onHoldOrRelease()} data-testid="holdCentre">
          Hold/release subjects
        </MenuItem>
        <MenuItem
          disabled={disableIssueReport}
          onClick={() => onIssueReport()}
          data-testid="issueOneReport"
        >
          Issue report
        </MenuItem>
        <MenuItem disabled={disableSoaPrint} onClick={() => onSoaPrint()} data-testid="printOneSoa">
          Send SoA to print queue
        </MenuItem>
      </Menu>
    </div>
  );
};

export default MoreActionMenu;
